if (!String.prototype.at) {
  // oxlint-disable-next-line no-extend-native -- this file's entire purpose is the polyfill
  String.prototype.at = function at(index) {
    index = Math.trunc(index) || 0;
    if (index < 0) {
      index += this.length;
    }
    if (index < 0 || index >= this.length) {
      return '';
    }
    return this.charAt(index);
  };
}
